import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { normalizeText } from '../shared/utils';

const TARGET_TEMPLATE_PATH =
  '/create/templates/default/dxm-sso-federation-intake-template';

const REVIEW_LABELS_TO_REMOVE = new Set([
  'saml xml upload',
  'metadata xml file',
  'signing certificate',
]);

function shouldRemoveRow(row: HTMLTableRowElement): boolean {
  const firstCell = row.querySelector('th, td');
  if (!firstCell?.textContent) return false;
  return REVIEW_LABELS_TO_REMOVE.has(normalizeText(firstCell.textContent));
}

function removeReviewRows(root: HTMLElement): void {
  const rows = Array.from(root.querySelectorAll('tr'));
  rows.forEach(row => {
    if (!(row instanceof HTMLTableRowElement)) return;
    if (!shouldRemoveRow(row)) return;
    row.remove();
  });
}

export function ScaffolderReviewCleanup() {
  const location = useLocation();

  useEffect(() => {
    const root = document.body;
    let observer: MutationObserver | undefined;

    if (location.pathname.startsWith(TARGET_TEMPLATE_PATH)) {
      removeReviewRows(root);

      observer = new MutationObserver(() => {
        removeReviewRows(root);
      });

      observer.observe(root, {
        childList: true,
        subtree: true,
      });
    }

    return () => observer?.disconnect();
  }, [location.pathname]);

  return null;
}
